import styled from 'styled-components';
import { Accordion } from 'react-bootstrap';

import { ChevronDown, GigReqMet, GigReqUnmet } from '@/assets/icons';

const AccordionTitle = styled.div`
  font-size: 14px;
  padding: 11px 16px 11px 44px;
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .progress {
    width: 109px;
    height: 4px;
    margin-left: 16px;

    &-container {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &-variant-success {
      color: #00af46;
    }

    &-variant-danger {
      color: #eb0000;
    }
  }

  &:not(.disable-collapse) {
    cursor: pointer;

    ::before {
      content: url(${ChevronDown});
      line-height: 0;
      position: absolute;
      left: 20px;
      transition: transform 0.2s ease-in-out;
    }
  }

  &.gigname {
    padding-right: 40px;

    background-image: url(${GigReqUnmet});
    background-repeat: no-repeat;
    background-position: 96% center;

    &.met {
      background-image: url(${GigReqMet});
    }
  }
`;

const StyledAccordion = styled(Accordion)`
  [data-key='${({ activeKey }) => activeKey}'] > ${AccordionTitle} {
    &::before {
      transform: rotate(-180deg);
    }
  }

  .collapsed & {
    display: none;
  }
`;

const StyledAccordionItem = styled.div`
  border-bottom: 1px solid #dee2e6;

  &:last-child {
    border-bottom: none;
  }
`;

const StyledChildAccordion = styled(Accordion)`
  padding-left: 44px;
  padding-right: 16px;

  .collapse,
  .collapsing {
    padding-left: 30px;
  }

  &:last-child {
    padding-bottom: 12px;
  }

  ${AccordionTitle} {
    padding-left: 24px;
    padding-right: 0;

    &::before {
      left: 0;
    }

    &.active {
      &::before {
        transform: rotate(-180deg);
      }
    }
  }
`;

const Weeks = styled.div`
  font-size: 12px;
  padding-top: 5px;
  padding-bottom: 12px;
  margin-bottom: 12px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const ScheduleDots = styled.div`
  position: absolute;
  bottom: 4px;
  display: flex;
  gap: 8px;
`;

const ScheduleDot = styled.div<{ color: string }>`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${props => props.color};
`;

export { AccordionTitle, StyledAccordion, StyledAccordionItem, StyledChildAccordion, Weeks, ScheduleDots, ScheduleDot };
